import * as deviceAccessStatuses from 'constants/device-access-statuses';
import internalEventCodes from 'event-system/codes/internal';

class DevicesManager {

  constructor(application) {

    this.application = application;
    this.microphoneStreams = [];
    this.cameraStreams = [];

  }

  endStream(stream) {

    const tracks = stream.getTracks();

    for (let track of tracks) {
      track.stop();
    }

  }

  async checkDevicesAccess(options) {

    const startTime = Date.now();

    try {

      const stream = await navigator.mediaDevices.getUserMedia(options);

      // here the goal is know the access status of the device, 
      // stream can be closed once obtained, as obtaining means "ALLOWED".
      this.endStream(stream);

      return deviceAccessStatuses.ALLOWED;

    } catch (exception) {

      const endTime = Date.now();
      const difference = endTime - startTime;

      if (difference <= 500) {
        return deviceAccessStatuses.BLOCKED;
      }

      return deviceAccessStatuses.DISALLOWED;

    }

  }

  async getDevicesStream(options) {

    const startTime = Date.now();

    try {

      const stream = await navigator.mediaDevices.getUserMedia(options);

      return stream;

    } catch (exception) {

      const endTime = Date.now();
      const difference = endTime - startTime;

      if (difference <= 500) {
        throw new Error(deviceAccessStatuses.BLOCKED);
      }

      throw new Error(deviceAccessStatuses.DISALLOWED);

    }

  }

  async getMicrophoneStream() {

    const stream = await this.getDevicesStream({ audio: true });

    this.microphoneStreams.push(stream);

    return stream;

  }

  async getCameraStream(options) {

    let video = true;

    if (options !== void 0) {
      video = options;
    }

    const stream = await this.getDevicesStream({ video });

    this.cameraStreams.push(stream);

    return stream;

  }

  checkMicrophoneAccess() {

    return this.checkDevicesAccess({ audio: true });

  }

  checkCameraAccess() {

    return this.checkDevicesAccess({ video: true });

  }

  checkMicrophoneAndCameraAccess() {

    return this.checkDevicesAccess({ audio: true, video: true });

  }

  async ensureMediaPermissions(_microphoneAccessStatus, _cameraAccessStatus) {

    let microphoneAccessStatus = _microphoneAccessStatus;
    let cameraAccessStatus = _cameraAccessStatus;

    if (microphoneAccessStatus === void 0 && cameraAccessStatus === void 0) {
      microphoneAccessStatus = cameraAccessStatus = await this.checkMicrophoneAndCameraAccess();
    } else {
      if (microphoneAccessStatus === void 0) {
        microphoneAccessStatus = await this.checkMicrophoneAccess();
      }

      if (cameraAccessStatus === void 0) {
        cameraAccessStatus = await this.checkCameraAccess();
      }
    }

    if (microphoneAccessStatus !== deviceAccessStatuses.ALLOWED || cameraAccessStatus !== deviceAccessStatuses.ALLOWED) {
      this.application.eventSystem.internal.emit(internalEventCodes.DISPLAY_MICROPHONE_AND_CAMERA_ACCESS_NEEDED_MESSAGE, {
        microphoneAccessStatus,
        cameraAccessStatus
      });
      return false;
    }

    return true;

  }

  releaseMicrophoneStream() {

    if (this.microphoneStreams.length === 0) {
      return;
    }

    const stream = this.microphoneStreams.pop();

    this.endStream(stream);

  }

  releaseCameraStream() {

    if (this.cameraStreams.length === 0) {
      return;
    }

    const stream = this.cameraStreams.pop();

    this.endStream(stream);

  }

}

export default DevicesManager;